<template>
    <div>
        <b-modal :id="modalId"
                 @hidden="onModalHidden()"
                 modal-class="modal-shipping-address"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-base-close"></div>
                    <p>{{title}}</p>
                </div>
                <div class="modal-base-body">
                    <FormShippingAddress @onSubmitForm="onSaveShippingAddress($event)"></FormShippingAddress>
                </div>
                <div class="modal-base-footer pt-2 text-center">
                    <button class="btn btn-secondary" @click="clickCancel()">{{btnOk}}</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/Locale.js";
import Util from "@/helper/Utility.js";
//component
import FormShippingAddress from "./component/FormShippingAddress.vue";
//service
import { RedeemShippingAddressConfigBuilder } from "@/core/Redeem/config/RedeemConfigBuilder.js";

/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ShippingAddressModal",
    components: {
        FormShippingAddress,
    },
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            title: '',
            message: '',
            btnOk: '',
            tag: '',
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        clickCancel: function() {
            this.hide();
        },
        show: function(config) {
            this.title = config.title;
            this.btnOk = config.btnOk;

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },

        onSaveShippingAddress: function(data) {
            // console.log(data);
            var builder = new RedeemShippingAddressConfigBuilder();
            builder.setAddress(data.getFullAddressText())
            builder.setContactNumber(data.contactNumber);
            builder.setShippingFirstName(data.firstname);
            builder.setShippingLastName(data.lastname);
            builder.setZipcode(data.zipcode);

            // var redeemShippingAddressConfig = builder.create();
            this.hide();
            this.controller.sendCallbackSaveAddress(builder);
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    .modal-shipping-address {
        @extend %modal-base;
    }
</style>
